function ReportTable({ objects }) {
  const totals = objects.reduce(
    (acc, report) => {
      acc.invited += report.invited;
      acc.showedUp += report.showedUp;
      acc.walkIn += report.walkIn;
      acc.interviewed += report.interviewed;
      acc.qualified += report.qualified;
      return acc;
    },
    { invited: 0, showedUp: 0, walkIn: 0, interviewed: 0, qualified: 0 }
  );
  return (
    <>
      <div
        className="table-responsive"
        style={{
          transition: `all 0.5s ease-in-out 0.3s`,
        }}
      >
        <table className="table table-hover table-bordered">
          <thead className="table-light">
            <tr>
              <th>NAME</th>
              <th>NO. OF INVITED APPLICANTS</th>
              <th>NO. SHOWED UP</th>
              <th>WALK-IN</th>
              <th>TOTAL INTERVIEWED</th>
              <th>NO.OF QUALIFIED</th>
              <th>REMARKS (INDICATE CLIENTS TO ENDORSE)</th>
            </tr>
          </thead>
          <tbody>
            {objects.length > 0 ? (
              objects.map((report) => (
                <tr key={report.id} className="text-center cursor-pointer">
                  <td>{report.name}</td>
                  <td>{report.invited}</td>
                  <td>{report.showedUp}</td>
                  <td>{report.walkIn}</td>
                  <td>{report.interviewed}</td>
                  <td>{report.qualified}</td>
                  {/* <td>{report.applicants.join(", ") || "------"}</td> */}
                  <td className="text-start">
                    {Array.isArray(report.applicants) &&
                    report.applicants.length > 0
                      ? report.applicants.map((applicant, index) => {
                          return (
                            <div
                              className="m-0 d-flex flex-wrap mb-3"
                              key={index}
                            >
                              <div className="d-flex">
                                <span>-</span>
                                <p className="m-0">{applicant}</p>
                              </div>

                              {report.clients && report.clients[index] ? (
                                <div className="d-flex">
                                  <p className="m-0">{"("}</p>
                                  <b>{report.clients[index]}</b> -
                                  <b>
                                    {report.locations &&
                                      report.locations[index]}
                                  </b>
                                  <p className="m-0">{")"}</p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          );
                        })
                      : "-/-/-/-/-/-"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No reports found for the selected date range
                </td>
              </tr>
            )}
            <tr className="table-secondary fw-bold text-center">
              <td>TOTAL</td>
              <td>{totals.invited}</td>
              <td>{totals.showedUp}</td>
              <td>{totals.walkIn}</td>
              <td>{totals.interviewed}</td>
              <td>{totals.qualified}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ReportTable;
